import React from 'react';
import PropTypes from 'prop-types';
import { simpleFontSize } from '../../utils/settings_builder';

export default function OnSaleOnly(props) {
  const {
    onChange,
    onSaleOnly,
    settings,
  } = props;

  if (!settings.showOnSaleOnly) {
    return null;
  }

  const {
    highLightColor: color,
    fontSize = simpleFontSize,
  } = settings;

  return (
    <div className="snapgadget_on_sale_only">
      <label htmlFor="snapgadget_on_sale_only_input">
        <input
          id="snapgadget_on_sale_only_input"
          className="snapgadget_on_sale_only_input"
          type="checkbox"
          value="1"
          checked={onSaleOnly}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span style={{ color, fontSize, paddingLeft: 2 }}>Only Show Items On Sale</span>
      </label>
    </div>
  );
}

OnSaleOnly.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSaleOnly: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  settings: PropTypes.shape({
    showOnSaleOnly: PropTypes.bool,
    highLightColor: PropTypes.string,
    fontSize: PropTypes.number,
  }).isRequired,
};

OnSaleOnly.defaultProps = {
  onSaleOnly: false,
};
